import React, { useEffect, useMemo, useState } from "react";
import PageContainer from "../../components/PageContainer";
import MainContent from "../../components/MainContent";
import ajaxSchool from "../../util/remote/ajaxSchool";
import { useTheme } from "../../DataStore/ThemeContext";
import { useSchool } from "../../DataStore/SchoolContext";
import PageTitle from "../../components/Common/PageTitle/PageTitle";
import ConfirmationDialog from "../../components/Common/ConfirmationDialog";
import Notification from "../../components/Common/Notification";


const BillingBatchPage = () => {
const {openSettings, setNotify} = useTheme();
const [selectedBatch, setSelectedBatch] = useState(null);
const {getBatchListing, batchListing, getCurrentBatch} = useSchool();
const [showMakeCurrent, setShowMakeCurrent] = useState(false);

useEffect(()=>{
    getBatchListing();
}, [])

const batches = useMemo(()=>{
    return Array.isArray(batchListing) ? batchListing : [];
}, [batchListing]);

const onRefresh = async()=>{
    await getBatchListing(true);
}
    
  const onEdit = (batchInfo)=>{
     openSettings("Edit Billing Batch", "EditFeesBatch", batchInfo);
  }
  

  const handleNewBatch = ()=>{
    openSettings("New Billing Batch", "NewFeesBatch", null, "Save Billing Batch");
  }

  const handleMakeCurrent = (batchInfo)=>{
    setSelectedBatch(batchInfo);
    setShowMakeCurrent(true);
  }

  const confirmMakeCurrent = async () => {
    const server_response = await ajaxSchool.switchBillingBatch(selectedBatch?.id);
    if(server_response.status === "OK"){
        setNotify(<Notification message={server_response.message} type="success" closable={false} />);
        onRefresh();
        getCurrentBatch(true);
    }else{
        setNotify(<Notification message={server_response.message} type="danger" closable={false} />);
    }
    setSelectedBatch(null); // Clear selection after setting current
  };

  return (
    <>
    <PageContainer>
      <MainContent>
        <PageTitle
          title="Billing Batch"
          description="Manage and configure billing batches for the school."
          iconClass="fa fa-calendar-alt"
          sticky={true}
        />

            <div className="billing-action-bar mb-4">
                <div className="action-group-left">
                    <button 
                    className="btn-primary-custom" 
                    onClick={handleNewBatch}
                    >
                        <i className="fa fa-plus"></i>
                        <span>New Billing Batch</span>
                    </button>
                    <div className="action-separator"></div>
                    <button className="btn-ghost-custom" onClick={onRefresh}>
                        <i className="fa fa-sync text-success"></i>
                        <span>Refresh List</span>
                    </button>
                </div>
                <div className="action-group-right text-muted font-size-sm">
                    Total Batches: <strong>{batches.length}</strong>
                </div>
            </div>

      
        <div className="row overflow-auto" style={{maxHeight: "60vh"}}>
            <div className="col-12">
  

  <div className="bb-wrap">
    <div className="bb-timeline">
      {batches.map((batch) => {
        const isCurrent = String(batch.current) === "1";
        const isSelected = String(selectedBatch?.id) === String(batch.id);

        return (
          <div
            key={batch.id}
            className={`bb-item ${isSelected ? "is-selected" : ""}`}
            onClick={() => setSelectedBatch(batch)}
            role="button"
            tabIndex={0}
          >
            <span className={`bb-dot ${isCurrent ? "is-current" : ""}`} />

            <div className="bb-left">
              <div className="bb-titleRow">
                <div className="bb-title" title={batch.batch_name}>
                  {batch.batch_name}
                </div>

                {isCurrent ? (
                  <span className="bb-pill">
                    <i className="fa fa-bolt" />
                    Current
                  </span>
                ) : (
                  <span className="bb-pill is-muted">
                    <i className="fa fa-clock" />
                    Inactive
                  </span>
                )}
              </div>

              <div className="bb-sub">
                <span className="bb-range">
                  <i className="fa fa-calendar-alt" />
                  {batch.start_date} <span style={{ opacity: 0.55 }}>→</span> {batch.end_date}
                </span>

                <span className="text-muted">
                  <i className="fa fa-hashtag mr-1" />
                  {batch.id}
                </span>
              </div>
            </div>

            <div className="bb-actions">
              {!isCurrent && (
                <button
                  type="button"
                  className="bb-btn"
                  onClick={() => handleMakeCurrent(batch)}
                  title="Set as current batch"
                >
                  <i className="fa fa-check" />
                  Set current
                </button>
              )}

              <button
                type="button"
                className="bb-btn bb-btn--ghost"
                onClick={(e) => {
                  e.stopPropagation();
                  onEdit(batch);
                }}
                title="Edit batch"
              >
                <i className="fa fa-pen" />
                Edit
              </button>
            </div>
          </div>
        );
      })}

      {batches.length === 0 && (
        <div className="text-muted small py-4 text-center">
          No batches found. Click <strong>New Billing Batch</strong> to create one.
        </div>
      )}
    </div>
  </div>
</div>

        </div>

        
      </MainContent>
    </PageContainer>

    <ConfirmationDialog
        title="Switch Billing Batch"
        alertDescription="Are you sure you want to make this billing batch the current active batch?"
        notes="This will affect billing operations for students."
        show={showMakeCurrent}
        handleClose={()=>setShowMakeCurrent(false)}
        handleConfirm={()=>confirmMakeCurrent()}
        buttonLabel="Make Current"
        value={selectedBatch ? selectedBatch.batch_name : ""}
        />
</>
  );
};

export default BillingBatchPage;
